import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const ReplaceIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                d="M3.02 8.5C2.85333 7.33333 3.11997 5.5 5.51997 5.5C7.91997 5.5 14.1867 5.5 17.02 5.5M17.02 5.5L14.02 2.5M17.02 5.5L14.02 8.5"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.98 11.5C17.1467 12.6667 16.88 14.5 14.48 14.5C12.08 14.5 5.81334 14.5 2.98 14.5M2.98 14.5L5.97998 17.5M2.98 14.5L5.97998 11.5"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
